<template>
  <span class="cuonter">
    <span>{{ text.length }} / {{ maxLength }}</span>
  </span>
</template>

<script>
export default {
  props: {
    maxLength: { type: Number, default: 200 },
    text: { type: String, default: '' },
  }
}
</script>

<style lang="scss" scoped>
  .counter {
    font-size: 14px;
    color: #474747
  }
</style>